import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Q1 2019 in Swizec LLC land #open",
  "description": "",
  "published": "2019-04-04T00:00:00.000Z",
  "redirect_from": ["/blog/q1-2019-in-swizec-llc-land-open/swizec/9007"],
  "categories": "Business",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`It's the end of Q1 – one of the hardworkingest periods of my life ever. Was it worth the sleepless nights and the stress? Time for an #open report`}</p>
    <p>{`Swizec LLC, Jan 1st 2019 – Mar 31st 2019`}</p>
    <p>{`🤑$105,160 total inflows`}</p>
    <p>{`💸$83,554 total outflows`}</p>
    <p>{`⏳716 hours`}</p>
    <p>{`Let's break it down 🤔`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2019/04/CleanShot-2019-04-04-at-09.10.27@2x-1024x497.png",
        "alt": null
      }}></img></p>
    <p>{`Inflows 👇`}</p>
    <p>{`👨‍⚕️$47,000 consulting`}</p>
    <p>{`👨‍💻$21,460 dayjob contracting`}</p>
    <p>{`💰$21,850 pulled from savings`}</p>
    <p>{`👾$14,556 product sales`}</p>
    <p>{`Savings make this inflows instead of revenue. I'll explain`}</p>
    <p>{`Outflows 👇`}</p>
    <p>{`💰$15,650 SEP IRA contribution`}</p>
    <p>{`💰$1560 savings`}</p>
    <p>{`🧛‍♂️$20200 taxes`}</p>
    <p>{`👩‍💻$5887 freelancers`}</p>
    <p>{`💻$1959 SaaS`}</p>
    <p>{`🤓$553 education`}</p>
    <p>{`👨‍⚕️$282 insurance`}</p>
    <p>{`🏍$1885 motorcycle`}</p>
    <p>{`🎟$223 ads`}</p>
    <p>{`Again savings make it outflows, not costs`}</p>
    <p>{`PS: $12,923 for staying alive&happy`}</p>
    <p>{`PPS: $20,670 credit card debt bye bye`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Bye bye credit card debt. That was fun let's never do it again `}<a parentName="p" {...{
          "href": "https://t.co/rTRjkLfM1X"
        }}>{`pic.twitter.com/rTRjkLfM1X`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1096434172590096384"
      }}>{`February 15, 2019`}</a></blockquote>
    <p>{`My day job is now a contracting gig. That happened in October. I still love them, they still love me. 4 days/week gives me more time to sidehustle and to everyone's surprise means I do better work at work. Less stress maybe?`}</p>
    <p>{`👌`}</p>
    <p>{`How on earth did I pull off both $47,000 in consulting AND $21,460 in day job contracting in just 3 months?`}</p>
    <p>{`$32,000 of that consulting was for work done in 2018 😇`}</p>
    <p>{`My year in review post mentions an outsanding invoice. This was that. Phew`}</p>
    <p><a parentName="p" {...{
        "href": "https://swizec.com/blog/sidehustled-180k-almost-killed-my-business/swizec/8835"
      }}>{`https://swizec.com/blog/sidehustled-180k-almost-killed-my-business/swizec/8835`}</a></p>
    <p>{`About those savings shenanigans ... pulling $21,850 from savings and putting $15,650 back into different savings ... not exactly a business move is it?`}</p>
    <p>{`Except it is. Lemme explain`}</p>
    <p><a parentName="p" {...{
        "href": "https://imgur.com/gallery/MdA04"
      }}>{`https://imgur.com/gallery/MdA04`}</a></p>
    <p>{`Some of it would have to go to taxes eventually. This March.`}</p>
    <p>{`Accountant ran the numbers and suggested I move some of that money into a SEP IRA fund instead. Lowers my taxes, but means I can't touch the money for ~30 years.`}</p>
    <p>{`So I did that.`}</p>
    <p>{`Better 65 year old Swizec have the money than Uncle Sam using it to drop bombs on innocent children, right? He sure ain't using it to solve homelessness or health care ...`}</p>
    <p>{`The $5,800 difference between what I pulled and what went back into a SEP ... that covered what I was short for in taxes. Paid taxes on time with no delay for the first time ever 💪`}</p>
    <p>{`Perhaps this year I'll even keep up with quarterly payments 😛`}</p>
    <p>{`What was I gonna say next ... oh yeah: Was it worth it?`}</p>
    <p>{`⏳352 hours day job`}</p>
    <p>{`⏰65 hours consulting`}</p>
    <p>{`⏲253 hours product stuff`}</p>
    <p>{`hm`}</p>
    <p>{`Removing work done last year, savings stuff, work that pays next quarter ...`}</p>
    <p>{`... $34/hour 🤔`}</p>
    <p>{`That's ... not great? I honestly can't tell anymore but I'm sure BigTech pays better than that. 😅`}</p>
    <p>{`But I got 3 months salary buffer so I got that going for me.`}</p>
    <p><img parentName="p" {...{
        "src": "/858f05dcabb1a8f76c1a0a7aeedd7515/media-TPl5N4Ci49ZQY-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`🎉 Ok but in terms of what went well Q1 was a great success! 🎉`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`started+finished a freelance project`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`(finally) launched ReactForDataViz.com`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`ran marathon`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`paid my taxes`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`paid off my credit card`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`2 workshops at Reactathon`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`1 new workshop built from scratch`}</p>
      </li>
    </ul>
    <p>{`And that one might present a whole new way forward beyond React + D3. ✌️`}</p>
    <p>{`As for what went wrong ... not much.`}</p>
    <p>{`@willfanguy left me for a BigCorp job after 3 years of helping on the side. Needed to focus to crush it.`}</p>
    <p>{`Dropped a bunch of balls during the ReactForDataViz.com launch. But I can pick those back up in April :)`}</p>
    <p>{`Now all I gotta do is figure out what I'm doing with Q2 🤔Was so focused on Q1 I forgot to make any plans for the future lol`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`End of Q1 – one of the hardworkingest periods of my life ever. Was it worth the sleepless nights and the stress? `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/open?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#open`}</a><br parentName="p"></br><br parentName="p"></br>{`Swizec LLC, Jan 1st 2019 – Mar 31st 2019`}<br parentName="p"></br><br parentName="p"></br>{`🤑$105,160 total inflows`}<br parentName="p"></br>{`💸$83,554 total outflows`}<br parentName="p"></br>{`⏳716 hours`}<br parentName="p"></br><br parentName="p"></br>{`Let's break it down 🤔`}<a parentName="p" {...{
          "href": "https://t.co/IgbuDeawHK"
        }}>{`https://t.co/IgbuDeawHK`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1113837427674640384"
      }}>{`April 4, 2019`}</a></blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      